import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { GripSize } from '../../api/models';

export type TABLE_TYPE = Table<GripSize>;

export const TABLE = 'gripSize';
const SCHEMA = 'gripSizeId, sortId';

class GripSizeDatabase implements DataRepository<GripSize> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<GripSize | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: GripSize, key: Key): Promise<GripSize> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: GripSize[]): Promise<GripSize[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<GripSize[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const GripSizeDB = new GripSizeDatabase(db);
